<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="门店名称">
          <el-input
            v-model="searchData.storeName"
            size="small"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="门店类型">
          <el-select
            v-model="searchData.storeType"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in dict_store_type"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人手机号">
          <el-input
            v-model="searchData.legalMobile"
            size="small"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="法人手机号">
          <el-input
              v-model="searchData.saLegalMobile"
              size="small"
              placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="创建时间" class="item">
          <el-date-picker
            style="width: 280px"
            v-model="searchData.timeSlot"
            size="small"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="区域负责人">
          <SelectAdminUser
            ref="areaFollowUserSelect"
            v-model="searchData.areaFollowUserId"
            :job-code="AdminJobCode.A001"
            width="200px"
            @input="handleAreaFollowUserSelect"
          />
        </el-form-item>
        <el-form-item label="建店人">
          <SelectAdminUser v-model="searchData.createUserId" :job-code="AdminJobCode.A001" />
        </el-form-item>
        <!-- <el-form-item label="合作模式">
          <el-select
            v-model="searchData.cooperationMode"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option
              v-for="item in cooperationModeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="成单奖励比例">
          <el-select
            v-model="searchData.enableRewardCombo"
            placeholder="请选择"
            size="small"
            clearable
          >
            <el-option label="已配置" :value="true" />
            <el-option label="未配置" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="门店等级">
          <el-select
            v-model="searchData.storeGradeList"
            placeholder="请选择"
            size="small"
            class="search-form-item"
            multiple
          >
            <el-option
              v-for="item in dict.StoreGradeList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
            <el-option key="" label="空" value="" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域">
          <el-cascader
            v-model="searchData.areaIds"
            :options="cascadeOptions"
            :props="cascadeProps"
            :show-all-levels="false"
            size="small"
            placeholder="请选择"
            clearable
            collapse-tags
          />
        </el-form-item>
        <el-form-item label="所属省市">
          <AreaSelector
            v-model="searchData.cityRegionList"
            :level="2"
            :props="{ multiple: true }"
            size="small"
            placeholder="请选择"
            clearable
            collapse-tags
          />
        </el-form-item>
        <el-form-item label="商家转账开通状态">
          <el-select
              v-model="searchData.alipayTransferStatus"
              placeholder="请选择"
              size="small"
              clearable
          >
            <el-option label="未录入" :value="false" />
            <el-option label="已录入" :value="true" />
          </el-select>
        </el-form-item>
        <el-form-item label="大订单结算开通状态">
          <el-select
              v-model="searchData.alipaySubMerchantStatus"
              placeholder="请选择"
              size="small"
              clearable
          >
            <el-option
                v-for="item in dict.AlipaySubMerchantStatusList"
                :key="item.value"
                :label="item.name"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            @click="getList"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            size="small"
            icon="el-icon-refresh"
            @click="reset"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>
    <div class="handle-btn">
      <div class="handle-btn-left">
        <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.store_list_add)"
          style="margin-bottom: 20px"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="$router.push({ name: 'StoreAdd' })"
        >
          新增
        </el-button>
      </div>
      <div class="handle-btn-right">
        <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.store_list_export)"
          size="small"
          icon="el-icon-download"
          type="primary"
          @click="exportExcel"
        >
          导出
        </el-button>
        <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.store_list_sjdr)"
          size="small"
          icon="el-icon-upload2"
          type="primary"
          @click="openDataImport"
        >
          数据导入
        </el-button>
        <el-dropdown
          v-checkbtn="isShowBtn(AUTH_BTN.store_list_plpzmb) || isShowBtn(AUTH_BTN.store_list_goods_price_tpl)"
          trigger="click"
          @command="handleBatchConfig"
        >
          <el-button size="small" icon="el-icon-setting" type="primary">
            批量配置模板<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-if="isShowBtn(AUTH_BTN.store_list_plpzmb)"
              command="combo"
            >配置方案模板</el-dropdown-item>
            <el-dropdown-item
              v-if="isShowBtn(AUTH_BTN.store_list_goods_price_tpl)"
              command="goodsPrice"
            >配置商品模板</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <tp-table
      :isNeedSerialNumber="false"
      :isCheckBox="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
      @handleSelectionChange="handleStoreSelectionChange"
    />

    <!-- 物料弹窗 -->
    <el-dialog
      :title="`门店名称：${storeName}`"
      :visible.sync="dialogVisibleMaterial"
      width="700px"
    >
      <el-divider content-position="center">h5物料</el-divider>
      <div class="code-img">
        <el-image style="width: 200px" fit="fill" :src="materialUrl"></el-image>
        <el-button
          style="margin-top: 10px"
          type="primary"
          size="small"
          @click="downloadMaterial"
        >
          下载
        </el-button>
      </div>
    </el-dialog>

    <!-- 支付宝物料弹窗 -->
    <el-dialog
      :title="`门店名称：${storeName}`"
      :visible.sync="dialogVisibleAlipayMaterial"
      width="700px"
    >
      <el-divider content-position="center">支付宝物料</el-divider>
      <div class="code-img">
        <el-image style="width: 200px" fit="fill" :src="alipayMaterialUrl" />
        <el-button
          style="margin-top: 10px"
          type="primary"
          size="small"
          @click="downloadAlipayMaterialImage"
        >
          下载
        </el-button>
      </div>
    </el-dialog>

    <!-- 方案计算器链接 -->
    <el-dialog
        title="方案计算器链接"
        :visible.sync="dialogVisibleComboLink"
        width="750px"
        :show-close="false"
        :center="true"
    >
      <el-table :data="comboLinkList" size="small" class="summary-table">
        <el-table-column prop="linkName" label="方案线路" width="80px"></el-table-column>
        <el-table-column prop="linkUrl" label="方案链接"></el-table-column>
        <el-table-column label="操作" align="" width="80px" fixed="right">
          <template slot-scope="scope">
            <el-link :underline="false" type="primary" @click="copyLink(scope.row.linkUrl)">复制</el-link>
          </template>
        </el-table-column>
      </el-table>

      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisibleComboLink = false">关闭</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-drawer
      class="store-detail-drawer"
      title="门店详情"
      :visible.sync="show_detail"
      direction="rtl"
      size="50%"
    >
      <div class="store-detail">
        <!-- 门店基础信息 -->
        <div class="detail-card">
          <div class="section-title">门店基础信息</div>
          <div class="info-list">
            <div class="info-row">
              <span class="info-label">门店名称</span>
              <span class="info-value">{{ detail.storeName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">门店等级</span>
              <span class="info-value">{{ detail.storeGrade ? detail.storeGrade + '级' : '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">门店类型</span>
              <span class="info-value">{{ detail.storeTypeName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">合作模式</span>
              <span class="info-value">{{
                detail.cooperationModeName ||
                (cooperationModeList.find((item) => item.value === detail.cooperationMode) || {})
                  .label ||
                "-"
              }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">区域负责人</span>
              <span class="info-value">{{ detail.areaFollowUserName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">建店人</span>
              <span class="info-value">{{ detail.createUserName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">建店时间</span>
              <span class="info-value">{{ detail.createTime || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">门店地址</span>
              <span class="info-value">{{ detail.address || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">门店标签</span>
              <span class="info-value">
                <el-tag
                  style="margin-right: 5px"
                  type="primary"
                  size="mini"
                  v-for="(item, i) in detail.storeTagList"
                  :key="i"
                >{{ item }}</el-tag>
                <span v-if="!detail.storeTagList || detail.storeTagList.length === 0">-</span>
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">门店负责人</span>
              <span class="info-value">{{ detail.legalName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">负责人手机号</span>
              <span class="info-value">{{ detail.legalMobile || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">门店照片</span>
              <span class="info-value">
                <el-image
                  style="width: 100px; height: 80px; margin-right: 8px"
                  v-for="(item, i) in detail.facadeImageUrlList"
                  :key="i"
                  :src="item"
                  :preview-src-list="detail.facadeImageUrlList"
                  fit="cover"
                />
              </span>
            </div>
          </div>

          <div class="section-title" style="margin-top: 20px;">门店资质信息</div>
          <div class="info-list">
            <div class="info-row">
              <span class="info-label">营业执照</span>
              <span class="info-value">
                <el-image
                    style="width: 100px; height: 80px"
                    :src="detail.licenseImageUrl"
                    :preview-src-list="[detail.licenseImageUrl]"
                    fit="cover"
                />
              </span>
            </div>
            <div class="info-row">
              <span class="info-label">营业执照名称</span>
              <span class="info-value">{{ detail.licenseName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">统一社会信用代码</span>
              <span class="info-value">{{ detail.licenseCreditCode || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">法人姓名</span>
              <span class="info-value">{{ detail.saLegalName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">法人手机号</span>
              <span class="info-value">{{ detail.saLegalMobile || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">法人身份证号</span>
              <span class="info-value">{{ detail.saLegalIdCardNo || '-' }}</span>
            </div>
          </div>

          <div class="section-title" style="margin-top: 20px;">增值服务</div>
          <div class="info-list">
            <div class="info-row">
              <span class="info-label">监管锁费</span>
              <span class="info-value">{{ detail.lockAmount }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">保险金系数</span>
              <span class="info-value">
                {{ detail.insuranceRate }}
                <span style="color: #f56c6c">（注：保险金=零售价*保险金系数）</span>
              </span>
            </div>
          </div>

          <div class="section-title" style="margin-top: 20px;">门店结算信息</div>
          <div class="info-list">
            <div class="info-row">
              <span class="info-label">商家转账收款人</span>
              <span class="info-value">{{ detail.payeeIdName || '-' }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">商家转账收款账号</span>
              <span class="info-value">{{ detail.payeeAlipayAccount || '-' }}</span>
            </div>
            <div class="info-row" v-if="detail.storeType === 1">
              <span class="info-label">大订单结算收款账号</span>
              <span class="info-value">{{ detail.alipaySubMerchantLogonId || '-' }}</span>
            </div>
          </div>
        </div>

        <!-- 门店核心数据 -->
        <div class="detail-card" style="margin-top: 16px;">
          <div class="section-title">门店核心数据</div>

          <div class="sub-title">订单数据</div>
          <div class="stats-grid stats-5">
            <div class="stat-card">
              <div class="stat-label">申请单量</div>
              <div class="stat-value">{{ detail.applyOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">成单量</div>
              <div class="stat-value">{{ detail.dealOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">在租单量</div>
              <div class="stat-value">{{ detail.rentOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">在逾订单</div>
              <div class="stat-value">{{ detail.overdueOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">结清订单</div>
              <div class="stat-value">{{ detail.fullPayOrderNum || 0 }}</div>
            </div>
          </div>

          <div class="sub-title">到期订单数据</div>
          <div class="stats-grid stats-3">
            <div class="stat-card">
              <div class="stat-label">到期订单数</div>
              <div class="stat-value">{{ detail.dueOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">到期逾期订单数</div>
              <div class="stat-value">{{ detail.dueOverdueOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">到期逾期率</div>
              <div class="stat-value">{{ detail.dueOverdueRate || '0%' }}</div>
            </div>
          </div>

          <div class="sub-title">近期订单数据</div>
          <div class="stats-grid stats-3">
            <div class="stat-card">
              <div class="stat-label">近期订单数</div>
              <div class="stat-value">{{ detail.recentOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">近期离线订单数</div>
              <div class="stat-value">{{ detail.recentOfflineOrderNum || 0 }}</div>
            </div>
            <div class="stat-card">
              <div class="stat-label">近期离线率</div>
              <div class="stat-value">{{ detail.recentOfflineRate || '0%' }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <ComboSetting
      :visible.sync="comboSettingProps.visible"
      :id="comboSettingProps.id"
      @refreshList="getList"
    />

    <StoreGrade
      :visible.sync="storeGradeProps.visible"
      :id="storeGradeProps.id"
      :grade="storeGradeProps.grade"
      @refreshList="getList"
    />

    <FollowRecord
      :visible.sync="followRecordProps.visible"
      :storeCode="followRecordProps.storeCode"
      :storeName="followRecordProps.storeName"
    />

    <TemplateBindDialog
      :visible.sync="templateBindDialog.visible"
      :store-id-list="templateBindDialog.storeIdList"
      :store-id="templateBindDialog.storeId"
      :current-tpl-id="templateBindDialog.currentTplId"
      @saved="onTemplateBindSaved"
    />

    <GoodsPriceTplSelectDialog
      :visible.sync="goodsPriceTplDialog.visible"
      :store-id-list="goodsPriceTplDialog.storeIdList"
      :store-id="goodsPriceTplDialog.storeId"
      :goods-type="goodsPriceTplDialog.goodsType"
      :current-tpl-id="goodsPriceTplDialog.currentTplId"
      @saved="onGoodsPriceTplSaved"
    />

    <DealRewardRateDialog
      :visible.sync="dealRewardRateDialog.visible"
      :id="dealRewardRateDialog.id"
      :current-rate="dealRewardRateDialog.currentRate"
      @saved="getList"
    />
    <DealRewardRateImport
      :visible.sync="dataImportVisible"
      @success="getList"
    />

    <JointCooperationDialog
      :visible.sync="jointCooperationDialog.visible"
      :store-id="jointCooperationDialog.storeId"
      @success="onJointCooperationSuccess"
      @close="onJointCooperationDialogClose"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  exportAPI,
  getListAPI,
  deleteStoreAPI,
  changeStatusAPI,
  changeWapStatusAPI,
  getQrcodeAPI,
  getStoreMaterialAPI,
  getStoreAlipayMaterialAPI,
  getStoreComboLinkAPI,
  downloadFile,
  getStoreDetailAPI,
  changeEnableLoginAPI,
  editAreaFollowStatusAPI,
  getTopAreaCascadeAPI,
  applyAlipaySubMerchantAPI,
  withdrawJointInviteAPI,
} from "./api";
import SelectAdminUser from "@/views/components/select-admin-user.vue";
import AreaSelector from "@/components/area-selector/index.vue";
import regions from "@/components/area-selector/region.js";
import ComboSetting from "@/views/store/combo/combo-setting.vue";
import StoreGrade from "./store-grade.vue";
import FollowRecord from "./follow-record.vue";
import TemplateBindDialog from "./components/template-bind-dialog.vue";
import GoodsPriceTplSelectDialog from "./components/goods-price-tpl-select-dialog.vue";
import DealRewardRateDialog from "./components/deal-reward-rate-dialog.vue";
import DealRewardRateImport from "./components/deal-reward-rate-import.vue";
import JointCooperationDialog from "./components/joint-cooperation-dialog.vue";
import {
  dict_store_type,
  StoreGradeList,
  StoreGradeToTextMap,
  AlipaySubMerchantStatusToTextMap,
  AlipaySubMerchantStatusList,
  AdminJobCode,
} from "@/enum/dict/index.js";

const columns = [
  {
    label: "门店ID",
    prop: "id",
    minWidth: "90",
    customRender(h, row) {
      return <p>{row["id"] || "-"}</p>;
    },
  },
  {
    label: "门店名称",
    prop: "storeName",
    minWidth: "200",
    customRender(h, row) {
      return (
        <p>
          {row["storeName"]}
          {row["storeTagList"].map((item) => {
            return (
              <el-tag type="danger" size="mini" style="margin-left: 5px;">
                {item}
              </el-tag>
            );
          })}
        </p>
      );
    },
  },
  {
    label: "合作模式",
    prop: "cooperationMode",
    minWidth: "100",
    customRender(h, row) {
      return (
        <p>
          {row["cooperationModeName"] ||
            ({ 1: "普通门店", 2: "返点门店" }[row["cooperationMode"]] || "-")}
        </p>
      );
    },
  },
  {
    label: "所属大区",
    prop: "topAreaName",
    minWidth: "110",
    customRender(h, row) {
      return <p>{row["topAreaName"] || "-"}</p>;
    },
  },
  {
    label: "二级分区",
    prop: "subAreaName",
    minWidth: "110",
    customRender(h, row) {
      return <p>{row["subAreaName"] || "-"}</p>;
    },
  },
  {
    label: "区域负责人",
    prop: "areaFollowUserName",
    minWidth: "110",
    customRender(h, row) {
      return <p>{row["areaFollowUserName"] || "-"}</p>;
    },
  },
  {
    label: "门店等级",
    prop: "storeGrade",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["storeGrade"] ? `${row["storeGrade"]}级` : "-"}</p>;
    },
  },
  {
    label: "成单奖励比例",
    prop: "storeRewardRate",
    minWidth: "120",
    customRender(h, row) {
      const rate = row["storeRewardRate"];
      return <p>{rate === 0 || rate ? `${rate}%` : "-"}</p>;
    },
  },
  {
    label: "门店类型",
    prop: "storeType",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["storeTypeName"]}</p>;
    },
  },
  {
    label: "商家转账开通状态",
    prop: "alipayTransferStatus",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["alipayTransferStatus"] ? "已录入" : "未录入"}</p>;
    },
  },
  {
    label: "大订单结算开通状态",
    prop: "alipaySubMerchantStatus",
    minWidth: "100",
    customRender(h, row) {
      return <p>{this.dict.AlipaySubMerchantStatusToTextMap.get(row["alipaySubMerchantStatus"])}</p>;
    },
  },
  {
    label: "监管锁费",
    prop: "lockAmount",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["lockAmount"]}</p>;
    },
  },
  {
    label: "建店人",
    prop: "createUserName",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["createUserName"]}</p>;
    },
  },
  {
    label: "添加时间",
    prop: "createTime",
    minWidth: "170",
    customRender(h, row) {
      return <p>{row["createTime"]}</p>;
    },
  },
  {
    label: "方案模板",
    prop: "tplName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["tplName"] || "-"}</p>;
    },
  },
  {
    label: "商品模板",
    prop: "goodsPriceTplName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["goodsPriceTplName"] || "-"}</p>;
    },
  },
  {
    label: "状态",
    prop: "status",
    minWidth: "120",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_status)}
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row["status"]}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      );
    },
  },
  // {
  //   label: "h5物料",
  //   prop: "enableWap",
  //   minWidth: "120",
  //   customRender(h, row) {
  //     return (
  //       <div>
  //         <el-switch
  //           disabled={!this.isShowBtn(this.AUTH_BTN.store_list_wap_status)}
  //           class="switch"
  //           onChange={() => this.changeWapStatus(row)}
  //           v-model={row["enableWap"]}
  //           active-value={true}
  //           inactive-value={false}
  //           active-text="启用"
  //           inactive-text="禁用"
  //         ></el-switch>
  //       </div>
  //     );
  //   },
  // },
  {
    label: "更改区域跟进人",
    prop: "enableAreaFollowEdit",
    minWidth: "150",
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_ggqygjr)}
            class="switch"
            onChange={() => this.changeAreaFollowConfigStatus(row)}
            v-model={row["enableAreaFollowEdit"]}
            active-value={true}
            inactive-value={false}
            active-text="开启"
            inactive-text="关闭"
          ></el-switch>
        </div>
      );
    },
  },
  {
    label: "操作",
    minWidth: "280",
    fixed: "right",
    customRender(h, row) {
      return (
        <div style="display: flex; flex-wrap: wrap; column-gap: 10px;">
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_detail)}
            underline={false}
            type="primary"
            onClick={() => this.handleDetail(row)}
          >
            详情
          </el-link>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_edit)}
            underline={false}
            type="primary"
            onClick={() => {
              this.$router.push({
                name: "StoreEdit",
                params: { id: row["id"] },
              });
            }}
          >
            编辑
          </el-link>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_copy)}
            underline={false}
            type="primary"
            onClick={() => this.copyLink(row["storeUrl"])}
          >
            复制链接
          </el-link>
          <el-link
            disabled={
              !this.isShowBtn(this.AUTH_BTN.store_list_wuliao) ||
              !row["enableWap"]
            }
            underline={false}
            type="primary"
            onClick={() => this.showMaterialImage(row)}
          >
            h5物料
          </el-link>
          <el-link
            disabled={ !this.isShowBtn(this.AUTH_BTN.store_list_alipay_material) || row["storeType"] != 1 }
            underline={false}
            type="primary"
            onClick={() => this.showAlipayMaterialImage(row)}
          >
            支付宝物料
          </el-link>
          <el-link
              disabled={ !this.isShowBtn(this.AUTH_BTN.store_list_combo_calc_link) }
              underline={false}
              type="primary"
              onClick={() => this.showComboCalcLink(row)}
          >
            方案计算器链接
          </el-link>
          <el-link
            underline={false}
            type="primary"
            onClick={() => this.showStoreGradeDialog(row)}
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_grade_config)}
          >
            等级配置
          </el-link>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_cdjlbl)}
            underline={false}
            type="primary"
            onClick={() => this.openDealRewardRateDialog(row)}
          >
            成单奖励比例
          </el-link>
          {/* <el-link
            underline={false}
            type="primary"
            onClick={() => this.showComboSettingDialog(row)}
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_combo_config)}
          >
            方案配置
          </el-link> */}
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_glfamb)}
            underline={false}
            type="primary"
            onClick={() => this.openTemplateBindDialog(row)}
          >
            关联方案模板
          </el-link>
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.store_list_goods_price_tpl)}
            underline={false}
            type="primary"
            onClick={() => this.openGoodsPriceTplDialog(row)}
          >
            关联商品模板
          </el-link>
          <el-link
            underline={false}
            type="primary"
            onClick={() => this.showFollowRecord(row)}
          >
            跟进记录
          </el-link>
          <el-link
              v-show={row["storeType"] == 1}
              disabled={
                !this.isShowBtn(this.AUTH_BTN.store_list_sqdddjs)
                || (row.alipaySubMerchantStatus === 1 || row.alipaySubMerchantStatus === 2)
              }
              underline={false}
              type="primary"
              onClick={() => this.applyAlipaySubMerchant(row)}
          >
            申请大订单结算
          </el-link>
          {!this.isJointCooperationBtnHidden(row) ? (
            <el-link
              disabled={
                !this.isShowBtn(this.AUTH_BTN.store_list_joint_cooperation)
              }
              underline={false}
              type="primary"
              onClick={() => this.openJointCooperationDialog(row)}
            >
              新增联营合作
            </el-link>
          ) : null}
          {row.jointInviteWithdrawable ? (
            <el-link
              disabled={
                !this.isShowBtn(this.AUTH_BTN.store_list_withdraw_joint_invite)
              }
              underline={false}
              type="danger"
              onClick={() => this.withdrawJointInvite(row)}
            >
              撤销联营邀约
            </el-link>
          ) : null}
        </div>
      );
    },
  },
];

export default {
  name: "StoreList",
  mixins: [authBtnMixin],
  components: {
    SelectAdminUser,
    AreaSelector,
    ComboSetting,
    StoreGrade,
    FollowRecord,
    TemplateBindDialog,
    GoodsPriceTplSelectDialog,
    DealRewardRateDialog,
    DealRewardRateImport,
    JointCooperationDialog,
  },
  data() {
    return {
      dialogVisibleMaterial: false,
      dialogVisibleAlipayMaterial: false,
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      selectedStoreList: [],
      searchData: {
        storeName: "",
        storeType: "",
        legalMobile: "",
        saLegalMobile: "",
        timeSlot: [],
        areaFollowUserName: "",
        areaFollowUserId: "",
        createUserId: "",
        cooperationMode: "",
        enableRewardCombo: "",
        alipayTransferStatus: "",
        alipaySubMerchantStatus: "",
        storeGradeList: [],
        areaIds: [],
        cityRegionList: [],
      },
      cascadeOptions: [],
      cascadeProps: {
        multiple: true,
        value: "id",
        label: "areaName",
        children: "subAreaList",
      },
      storeName: "",
      url: "",
      qrcodeUrl: "",
      materialUrl: "",
      alipayMaterialUrl: "",
      show_detail: false,
      detail: {},
      activeName: "first",
      dict_store_type,
      AdminJobCode,
      cooperationModeList: [
        {
          label: "普通门店",
          value: 1,
        },
        {
          label: "返点门店",
          value: 2,
        },
      ],
      comboSettingProps: {
        visible: false,
        id: null,
      },
      followRecordProps: {
        visible: false,
        storeCode: '',
        storeName: '',
      },
      templateBindDialog: {
        visible: false,
        storeId: null,
        storeIdList: [],
        currentTplId: null,
      },
      goodsPriceTplDialog: {
        visible: false,
        storeId: null,
        storeIdList: [],
        goodsType: 1,
        currentTplId: null,
      },
      dealRewardRateDialog: {
        visible: false,
        id: null,
        currentRate: 0,
      },
      dataImportVisible: false,
      storeGradeProps: {
        visible: false,
        id: null,
        grade: null,
      },
      dict: {
        StoreGradeList,
        StoreGradeToTextMap,
        AlipaySubMerchantStatusToTextMap,
        AlipaySubMerchantStatusList,
      },
      jointCooperationDialog: {
        visible: false,
        storeId: null,
      },
      comboLinkList: [],
      dialogVisibleComboLink: false,
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
    this.getCascadeOptions();
  },
  methods: {
    handleAreaFollowUserSelect(userId) {
      if (!userId) {
        this.searchData.areaFollowUserName = "";
        this.searchData.areaFollowUserId = "";
        return;
      }

      const list = this.$refs.areaFollowUserSelect?.list || [];
      const selectedUser = list.find((item) => item.id === userId);

      this.searchData.areaFollowUserId = userId;
      this.searchData.areaFollowUserName = selectedUser ? selectedUser.userName : "";
    },
    async getCascadeOptions() {
      const res = await getTopAreaCascadeAPI();
      this.cascadeOptions = res || [];
    },
    showFollowRecord(row) {
      this.followRecordProps.storeCode = row.storeCode
      this.followRecordProps.storeName = row.storeName
      this.followRecordProps.visible = true
    },
    /** 列表 jointActive 为 true 时隐藏「新增联营合作」 */
    isJointCooperationBtnHidden(row) {
      return row.jointActive === true;
    },
    openJointCooperationDialog(row) {
      this.jointCooperationDialog.storeId = row.id;
      this.jointCooperationDialog.visible = true;
    },
    onJointCooperationSuccess() {
      this.getList();
    },
    onJointCooperationDialogClose() {
      this.jointCooperationDialog.storeId = null;
    },
    /** 撤销联营邀约 */
    withdrawJointInvite(row) {
      this.$confirm(
        "撤销后签署链接失效,可重新发起联营邀约，是否确认",
        "提示",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        },
      )
        .then(() => {
          withdrawJointInviteAPI({ storeId: row.id }).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },
    handleStoreSelectionChange(val) {
      this.selectedStoreList = val || [];
    },
    openTemplateBindDialog(row) {
      this.templateBindDialog.visible = true;
      this.templateBindDialog.storeId = row.id;
      this.templateBindDialog.storeIdList = [row.id];
      this.templateBindDialog.currentTplId = row.tplId || null;
    },
    openBatchTemplateBindDialog() {
      const storeIdList = (this.selectedStoreList || []).map((item) => item.id);
      if (!storeIdList.length) {
        this.$message.error("请先勾选门店");
        return;
      }
      this.templateBindDialog.visible = true;
      this.templateBindDialog.storeId = null;
      this.templateBindDialog.storeIdList = storeIdList;
      this.templateBindDialog.currentTplId = null;
    },
    onTemplateBindSaved() {
      this.getList();
    },
    // 单个门店关联商品模板
    openGoodsPriceTplDialog(row) {
      this.goodsPriceTplDialog.visible = true;
      this.goodsPriceTplDialog.storeId = row.id;
      this.goodsPriceTplDialog.storeIdList = [row.id];
      this.goodsPriceTplDialog.goodsType = row.storeType || 1;
      this.goodsPriceTplDialog.currentTplId = row.goodsPriceTplId || null;
    },
    // 批量配置 - 下拉菜单分发
    handleBatchConfig(command) {
      if (command === "combo") {
        this.openBatchTemplateBindDialog();
      } else if (command === "goodsPrice") {
        this.openBatchGoodsPriceTplDialog();
      }
    },
    // 批量配置商品模板 - 校验 storeType 一致性
    openBatchGoodsPriceTplDialog() {
      const storeList = this.selectedStoreList || [];
      if (!storeList.length) {
        this.$message.error("请先勾选门店");
        return;
      }
      const storeTypes = [...new Set(storeList.map((item) => item.storeType))];
      if (storeTypes.length > 1) {
        this.$message.error("选中的门店类型不一致（同时包含3C和电车门店），请只选择一种类型的门店");
        return;
      }
      const goodsType = storeTypes[0] || 1;
      this.goodsPriceTplDialog.visible = true;
      this.goodsPriceTplDialog.storeId = null;
      this.goodsPriceTplDialog.storeIdList = storeList.map((item) => item.id);
      this.goodsPriceTplDialog.goodsType = goodsType;
      this.goodsPriceTplDialog.currentTplId = null;
    },
    onGoodsPriceTplSaved() {
      this.getList();
    },
    openDealRewardRateDialog(row) {
      this.dealRewardRateDialog.id = row.id;
      this.dealRewardRateDialog.currentRate = Number(row.storeRewardRate || 0);
      this.dealRewardRateDialog.visible = true;
    },
    showStoreGradeDialog(row) {
      this.storeGradeProps.visible = true;
      this.storeGradeProps.id = row.id;
      this.storeGradeProps.grade = row.storeGrade;
    },
    showComboSettingDialog(row) {
      this.comboSettingProps.visible = true;
      this.comboSettingProps.id = row.id;
    },
    // 详情
    async handleDetail({ id }) {
      this.detail = await getStoreDetailAPI(id);
      this.show_detail = true;
    },
    applyAlipaySubMerchant({ id }) {
      this.$confirm("确定已完善资料并申请开通大订单结算功能吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            applyAlipaySubMerchantAPI(id).then(() => {
              this.getList();
              this.$message({
                type: "success",
                message: "操作成功!",
              });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
    },
    async getList() {
      const {
        storeName,
        storeType,
        storeGradeList,
        legalMobile,
        saLegalMobile,
        timeSlot,
        areaFollowUserName,
        areaFollowUserId,
        createUserId,
        cooperationMode,
        enableRewardCombo,
        alipayTransferStatus,
        alipaySubMerchantStatus,
        areaIds,
        cityRegionList,
      } = this.searchData;
      const subAreaIds = areaIds.map((path) => path[path.length - 1]);
      const cityList = cityRegionList.map((path) => {
        const province = regions.find((prov) => prov.regionId === path[0]);
        const city = (province?.children || []).find(
          (item) => item.regionId === path[path.length - 1],
        );
        return city?.regionName || "";
      });
      let params = {
        storeName,
        storeType,
        storeGradeList: storeGradeList.join(),
        legalMobile,
        saLegalMobile,
        areaFollowUserName,
        areaFollowUserId,
        createUserId,
        cooperationMode,
        enableRewardCombo,
        alipayTransferStatus,
        alipaySubMerchantStatus,
        subAreaIds: subAreaIds.join(),
        cityList: cityList.join(),
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0];
        params.rightCreateDate = timeSlot[1];
      }
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    // 导出
    exportExcel() {
      const {
        storeName,
        storeType,
        storeGradeList,
        legalMobile,
        saLegalMobile,
        timeSlot,
        areaFollowUserName,
        areaFollowUserId,
        createUserId,
        cooperationMode,
        enableRewardCombo,
        alipayTransferStatus,
        alipaySubMerchantStatus,
      } = this.searchData;
      let params = {
        storeName,
        storeGradeList,
        storeType,
        legalMobile,
        saLegalMobile,
        areaFollowUserName,
        areaFollowUserId,
        createUserId,
        cooperationMode,
        enableRewardCombo,
        alipayTransferStatus,
        alipaySubMerchantStatus,
        page: this.currentPage,
        pageSize: this.pageSize,
      };
      if (timeSlot && timeSlot.length > 0) {
        params.leftCreateDate = timeSlot[0];
        params.rightCreateDate = timeSlot[1];
      }
      exportAPI(params);
    },
    openDataImport() {
      this.dataImportVisible = true;
    },
    // 删除
    handleDel({ id }) {
      this.$confirm("此操作将永久删除该门店, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteStoreAPI(id).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 启用/禁用
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let statusDesc = status ? "启用" : "禁用";

      this.$confirm(`此操作将${statusDesc}该门店, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.status = status;
          changeStatusAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.status = !status;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    changeEnableLogin(row) {
      let { id, enableLogin } = row;
      let data = { id, enableLogin };
      let statusDesc = enableLogin ? "启用" : "禁用";
      this.$confirm(`此操作将${statusDesc}该门店登录, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.enableLogin = enableLogin;
          changeEnableLoginAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.enableLogin = !enableLogin;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    changeAreaFollowConfigStatus(row) {
      const { id, enableAreaFollowEdit } = row;
      const data = { id, enableAreaFollowEdit };
      const configStatusText = enableAreaFollowEdit ? "可配置" : "不可配置";

      this.$confirm(`操作会使门店区域跟进人变为${configStatusText}，是否继续？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.enableAreaFollowEdit = enableAreaFollowEdit;
          editAreaFollowStatusAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.enableAreaFollowEdit = !enableAreaFollowEdit;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    changeWapStatus(row) {
      let { id, enableWap } = row;
      let data = { id, enableWap };
      let enableWapDesc = enableWap ? "启用" : "禁用";

      this.$confirm(`此操作将${enableWapDesc}h5物料，是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          row.enableWap = enableWap;
          changeWapStatusAPI(data).then(() => {
            this.getList();
            this.$message.success("操作成功");
          });
        })
        .catch(() => {
          row.enableWap = !enableWap;
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    },
    async showCode(row) {
      this.qrcodeUrl = "";
      const { storeName, id } = row;
      const res = await getQrcodeAPI(id);
      this.storeName = storeName;
      this.$nextTick(function () {
        this.qrcodeUrl = res.qrImageUrl;
        this.dialogVisible = true;
      });
    },
    async showMaterialImage(row) {
      this.materialUrl = "";
      const { storeName, id } = row;
      const res = await getStoreMaterialAPI(id);
      this.storeName = storeName;
      this.$nextTick(function () {
        this.materialUrl = res.materialImageUrl;
        this.dialogVisibleMaterial = true;
      });
    },
    downloadMaterial() {
      downloadFile(this.materialUrl, this.storeName);
    },
    async showAlipayMaterialImage(row) {
      this.alipayMaterialUrl = "";
      const { storeName, id } = row;
      const res = await getStoreAlipayMaterialAPI(id);
      this.storeName = storeName;
      this.$nextTick(function () {
        this.alipayMaterialUrl = res.alipayMaterialImageUrl;
        this.dialogVisibleAlipayMaterial = true;
      });
    },
    downloadAlipayMaterialImage() {
      downloadFile(this.alipayMaterialUrl, this.storeName);
    },
    async showComboCalcLink(row) {
      const res = await getStoreComboLinkAPI(row.id);
      this.$nextTick(function () {
        this.comboLinkList = res;
        this.dialogVisibleComboLink = true;
      });
    },
    copyLink(url) {
      this.$copyText(url).then(
        () => {
          this.$message.success("复制成功");
        },
        () => {
          this.$message.error("复制失败");
        },
      );
    },
    resetPw(id) {
      this.$set(this.resetPwData, "id", id);
      this.dialogVisiblePw = true;
    },
    savePw() {
      resetPwAPI(this.resetPwData).then(() => {
        this.dialogVisiblePw = false;
        this.$message.success("重置成功");
        this.getList();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  .header-search /deep/ {
    .el-range-separator {
      padding: 0;
    }
  }
  .handle-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .handle-btn-right {
      margin-left: auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 10px;
    }
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .el-form {
    .el-form-item {
      margin-right: 35px;
    }
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .code-img {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .store-detail {
    padding: 20px;

    .detail-card {
      background: #fff;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      padding: 20px;
    }

    .section-title {
      font-size: 15px;
      font-weight: 600;
      color: #303133;
      padding-bottom: 12px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 4px;
    }

    .sub-title {
      font-size: 13px;
      font-weight: 600;
      color: #606266;
      margin: 16px 0 10px;
    }

    .info-list {
      .info-row {
        display: flex;
        align-items: flex-start;
        padding: 10px 0;
        border-bottom: 1px solid #f5f7fa;

        &:last-child {
          border-bottom: none;
        }

        .info-label {
          width: 150px;
          min-width: 150px;
          color: #606266;
          font-size: 14px;
        }

        .info-value {
          flex: 1;
          color: #303133;
          font-size: 14px;
        }
      }
    }

    .stats-grid {
      display: grid;
      gap: 10px;
      margin-bottom: 4px;

      &.stats-5 {
        grid-template-columns: repeat(5, 1fr);
      }

      &.stats-3 {
        grid-template-columns: repeat(3, 1fr);
      }

      .stat-card {
        border: 1px solid #ebeef5;
        border-radius: 4px;
        padding: 14px 10px;
        text-align: center;

        .stat-label {
          font-size: 12px;
          color: #909399;
          margin-bottom: 8px;
        }

        .stat-value {
          font-size: 22px;
          font-weight: 600;
          color: #303133;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .el-dialog__body {
    padding: 20px 20px 50px 20px;
  }
  .el-drawer__body {
    overflow-y: auto;
    padding: 0;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }

  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }

  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }

  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }

  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }

  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}

  .store-detail-drawer /deep/ .el-drawer__header {
    margin-bottom: 0;
  }
</style>
